export default {
    exportName: 'AdminConsoleInfo',
    content: () => import('@/Fwamework/Core/Components/LogsAdminConsole.vue'),
    contentData: {
        key: 'LogsAdminConsole',
        visible: true
    }
};